import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subject, debounceTime } from 'rxjs';
import { LogoLibraryResponse } from 'src/app/core/interfaces/logoLibraryResponse';

@Component({
    selector: 'app-logo-selector',
    templateUrl: './logo-selector.component.html',
    styleUrls: ['./logo-selector.component.scss'],
    standalone: false
})
export class LogoSelectorComponent implements OnInit {
  @Input('dataSet') set dataSet(value: LogoLibraryResponse[]) {
    if (value) {
      this.allLogos = value;
      this.filteredLogos = [...this.allLogos];
      this.filterText = '';
    }
  }

  @Input('selectedItem') selectedItem: LogoLibraryResponse;

  @Input('disabled') disabled: boolean = false;

  get dataSet(): any {
    return this.allLogos;
  }

  @Output() logoSelected: EventEmitter<LogoLibraryResponse> =
    new EventEmitter<LogoLibraryResponse>();
  @ViewChild(MatMenuTrigger) menu: MatMenuTrigger;
  @ViewChild('logoSelector', { static: false })
  logoSelector: ElementRef<HTMLElement>;

  constructor() {}

  debouncer: Subject<string> = new Subject();
  selectItem: LogoLibraryResponse = {
    id: '3986437D-0B6E-4976-9ED9-ACD057E5DB1E',
    name: 'HavrionTV',
    path: 'https://stghpstaticwebdev.z13.web.core.windows.net/iptv-channel-logos/htv-logo-full.svg',
    is_default: true
  };
  filterText: string = '';
  filteredLogos: LogoLibraryResponse[] = [];
  allLogos: LogoLibraryResponse[] = [];

  ngOnInit(): void {
    this.debouncer.pipe(debounceTime(300)).subscribe((value) => {
      this.buildFilteredLogos(value);
    });
  }

  onMenuOpened() {
    this.logoSelector.nativeElement.style.setProperty(
      'border',
      '2px solid rgba(var(--iptv-brand-green-rgb), 1)'
    );
  }

  onMenuClosed() {
    this.logoSelector.nativeElement.style.setProperty(
      'border',
      '2px solid rgba(255, 255, 255, 0.2)'
    );
  }

  keyPressed() {
    this.debouncer.next(this.filterText);
  }

  refocus(focusEvent: FocusEvent) {
    setTimeout(() => {
      const inputElement = focusEvent.target as HTMLInputElement;
      inputElement.focus();
    }, 20);
  }

  buildFilteredLogos(value: string) {
    if (value == '') {
      this.filteredLogos = [...this.allLogos];
    }

    this.filteredLogos = this.allLogos.filter((logo) => {
      return logo.name.toLowerCase().includes(value.toLowerCase());
    });
  }

  menuItemClicked(clickEvent: Event, item: LogoLibraryResponse) {
    clickEvent.preventDefault();
    clickEvent.stopPropagation();
    this.selectItem = item;
    this.menu.closeMenu();
    this.logoSelected.emit(item);
  }
}
